import { connect } from 'react-redux'
import { AppStateType } from '../../reducers'
import { selectAreaReadable } from '../../selectors/auth'
import { AREA_CONSTANTS } from '../../services/auth'
import { CapabilitiesPage as Component } from './CapabilitiesPage'

const mapStateToProps = (state: AppStateType) => ({
  canViewCreateCapabilityPage: selectAreaReadable(state, { area: AREA_CONSTANTS.SETTINGS_CREATE_CAPABILITY }),
})

export const CapabilitiesPage = connect(mapStateToProps)(Component)
